<p-confirmDialog #cd [style]="{ width: '335px' }">
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="mr-auto flex-fill">
        <h3 class="title">Session timeout</h3>
      </div>
      <div class="">
        <img
          class="close-icon"
          src="assets/images/close-icon.svg"
          (click)="cd.reject()"
          (keyup.enter)="cd.reject()"
          tabindex="0"
          role="button"
          alt="close-icon"
        />
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="btn-wrapper">
      <button type="button" class="btn btn-white" (click)="cd.reject()">Logout</button>
      <button type="button" class="btn btn-sky-blue" (click)="cd.accept()">Stay LogIn</button>
    </div>
  </ng-template>
</p-confirmDialog>
